// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".topbarnav {\n  width: calc(100% + 15px) !important;\n}", "",{"version":3,"sources":["webpack://src/components/navigational-component/topbar-nav/topbar-nav.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;AACF","sourcesContent":[".topbarnav{\n  width: calc(100% + 15px) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
